import PropTypes from 'prop-types';

import BurgerIcon from '@/images/header/burger.svg?react';

import s from './btnMenu.module.css';

function BtnMenu({ onClick }) {
  return (
    <button type="button" onClick={onClick} className={s.btn_menu} title="menu">
      <BurgerIcon />
    </button>
  );
}

export default BtnMenu;

BtnMenu.propTypes = {
  onClick: PropTypes.func.isRequired,
};
